<template>
  <div class="line-box">
    <div v-for="item in items"  class="line-sbox" v-bind:key="item.identifier">
      <h4 class="line-title">{{ item.title }}</h4>
      <div class="line-thumb"><router-link :to="'\/uuid\/' + item.identifier"><img v-bind:src="item.thumbnail" alt="" /></router-link></div>
      <div class="line-info-rbox">
        <div class="line-info-box">
          <div class="line-info-sbox">
            <dl>
              <dt>作成日(撮影日)</dt>
              <dd>{{item.created| dateFormatter}}</dd>
            </dl>
            <dl>
              <dt>撮影場所</dt>
              <!-- spatial	"宮城県多賀城市大代１丁目５"
                   lat	"38.292327880859375"
                   lon	"141.03643798828125"
              -->
              <dd>{{ item.spatial }}<span><a v-if="maplink(item)" v-bind:href="maplink(item)" class="btn-map-s" target="_blank">MAP</a></span></dd>
            </dl>
            <dl>
              <dt>撮影者:</dt>
              <dd><span v-for="c in item.creator" v-bind:key="c">{{ c }}</span></dd>
            </dl>
            <dl>
              <dt>投稿日:</dt>
              <dd>{{item.dateSubmitted| dateFormatter}}</dd>
            </dl>
          </div>
          <div class="line-comment-box">{{ item.description }}</div>
        </div>
        <div class="btn-det-box"><router-link :to="'\/uuid\/' + item.identifier"><span>詳しく見る<img src="../assets/arw_r.png" alt=""></span></router-link></div>
      </div>
    </div>
    <template v-if="false">
      <div class="line-sbox">
        <h4 class="line-title">宮城県 亘理郡亘理町 吉田</h4>
        <div class="line-thumb"><router-link to="/uuid"><img src="../assets/logo.png" alt="" /></router-link></div>
        <div class="line-info-rbox">
          <div class="line-info-box">
            <div class="line-info-sbox">
              <dl>
                <dt>作成日(撮影日)</dt>
                <dd>2012年02月17日 08時36分00秒</dd>
              </dl>
              <dl>
                <dt>撮影場所</dt>
                <dd>宮城県 亘理郡亘理町 吉田<span><a href="http://maps.google.co.jp/maps?q=%E5%AE%AE%E5%9F%8E%E7%9C%8C+%E4%BA%98%E7%90%86%E9%83%A1%E4%BA%98%E7%90%86%E7%94%BA+%E5%90%89%E7%94%B0&hl=ja&ie=UTF8&sll=38.005799,140.856633&sspn=0.176379,0.259552&brcurrent=3,0x5f8a13e473af7b3b:0xf22068a70b5e9ef2,0&hnear=%E5%AE%AE%E5%9F%8E%E7%9C%8C%E4%BA%98%E7%90%86%E9%83%A1%E4%BA%98%E7%90%86%E7%94%BA%E5%90%89%E7%94%B0&t=m&z=12" class="btn-map-s" target="_blank">MAP</a></span></dd>
              </dl>
              <dl>
                <dt>撮影者:</dt>
                <dd>みやちゃん</dd>
              </dl>
              <dl>
                <dt>投稿日:</dt>
                <dd>2013年01月04日 13時34分26秒</dd>
              </dl>
            </div>
            <div class="line-comment-box">亘理町吉田付近を地震後の津波襲来前の平成23年3月11日に撮影。</div>
          </div>
          <div class="btn-det-box"><router-link to="/uuid">詳しく見る <img src="../assets/arw_r.png" alt=""></router-link></div>
        </div>
      </div>
      <div class="line-sbox">
        <h4 class="line-title">宮城県 亘理郡亘理町 吉田</h4>
        <div class="line-thumb"><router-link to="/uuid"><img src="../assets/logo.png" alt="" /></router-link></div>
        <div class="line-info-rbox">
          <div class="line-info-box">
            <div class="line-info-sbox">
              <dl>
                <dt>作成日(撮影日)</dt>
                <dd>2012年02月17日 08時36分00秒</dd>
              </dl>
              <dl>
                <dt>撮影場所</dt>
                <dd>宮城県 亘理郡亘理町 吉田<span><a href="http://maps.google.co.jp/maps?q=%E5%AE%AE%E5%9F%8E%E7%9C%8C+%E4%BA%98%E7%90%86%E9%83%A1%E4%BA%98%E7%90%86%E7%94%BA+%E5%90%89%E7%94%B0&hl=ja&ie=UTF8&sll=38.005799,140.856633&sspn=0.176379,0.259552&brcurrent=3,0x5f8a13e473af7b3b:0xf22068a70b5e9ef2,0&hnear=%E5%AE%AE%E5%9F%8E%E7%9C%8C%E4%BA%98%E7%90%86%E9%83%A1%E4%BA%98%E7%90%86%E7%94%BA%E5%90%89%E7%94%B0&t=m&z=12" class="btn-map-s" target="_blank">MAP</a></span></dd>
              </dl>
              <dl>
                <dt>撮影者:</dt>
                <dd>みやちゃん</dd>
              </dl>
              <dl>
                <dt>投稿日:</dt>
                <dd>2013年01月04日 13時34分26秒</dd>
              </dl>
            </div>
            <div class="line-comment-box">亘理町吉田付近を地震後の津波襲来前の平成23年3月11日に撮影。</div>
          </div>
          <div class="btn-det-box"><router-link to="/uuid">詳しく見る <img src="../assets/arw_r.png" alt=""></router-link></div>
        </div>
      </div>
      <div class="line-sbox">
        <h4 class="line-title">宮城県 亘理郡亘理町 吉田</h4>
        <div class="line-thumb"><router-link to="/uuid"><img src="../assets/logo.png" alt="" /></router-link></div>
        <div class="line-info-rbox">
          <div class="line-info-box">
            <div class="line-info-sbox">
              <dl>
                <dt>作成日(撮影日)</dt>
                <dd>2012年02月17日 08時36分00秒</dd>
              </dl>
              <dl>
                <dt>撮影場所</dt>
                <dd>宮城県 亘理郡亘理町 吉田<span><a href="http://maps.google.co.jp/maps?q=%E5%AE%AE%E5%9F%8E%E7%9C%8C+%E4%BA%98%E7%90%86%E9%83%A1%E4%BA%98%E7%90%86%E7%94%BA+%E5%90%89%E7%94%B0&hl=ja&ie=UTF8&sll=38.005799,140.856633&sspn=0.176379,0.259552&brcurrent=3,0x5f8a13e473af7b3b:0xf22068a70b5e9ef2,0&hnear=%E5%AE%AE%E5%9F%8E%E7%9C%8C%E4%BA%98%E7%90%86%E9%83%A1%E4%BA%98%E7%90%86%E7%94%BA%E5%90%89%E7%94%B0&t=m&z=12" class="btn-map-s" target="_blank">MAP</a></span></dd>
              </dl>
              <dl>
                <dt>撮影者:</dt>
                <dd>みやちゃん</dd>
              </dl>
              <dl>
                <dt>投稿日:</dt>
                <dd>2013年01月04日 13時34分26秒</dd>
              </dl>
            </div>
            <div class="line-comment-box">亘理町吉田付近を地震後の津波襲来前の平成23年3月11日に撮影。</div>
          </div>
          <div class="btn-det-box"><router-link to="/uuid">詳しく見る <img src="../assets/arw_r.png" alt=""></router-link></div>
        </div>
      </div>
      <div class="line-sbox">
        <h4 class="line-title">宮城県 亘理郡亘理町 吉田</h4>
        <div class="line-thumb"><router-link to="/uuid"><img src="../assets/logo.png" alt="" /></router-link></div>
        <div class="line-info-rbox">
          <div class="line-info-box">
            <div class="line-info-sbox">
              <dl>
                <dt>作成日(撮影日)</dt>
                <dd>2012年02月17日 08時36分00秒</dd>
              </dl>
              <dl>
                <dt>撮影場所</dt>
                <dd>宮城県 亘理郡亘理町 吉田<span><a href="http://maps.google.co.jp/maps?q=%E5%AE%AE%E5%9F%8E%E7%9C%8C+%E4%BA%98%E7%90%86%E9%83%A1%E4%BA%98%E7%90%86%E7%94%BA+%E5%90%89%E7%94%B0&hl=ja&ie=UTF8&sll=38.005799,140.856633&sspn=0.176379,0.259552&brcurrent=3,0x5f8a13e473af7b3b:0xf22068a70b5e9ef2,0&hnear=%E5%AE%AE%E5%9F%8E%E7%9C%8C%E4%BA%98%E7%90%86%E9%83%A1%E4%BA%98%E7%90%86%E7%94%BA%E5%90%89%E7%94%B0&t=m&z=12" class="btn-map-s" target="_blank">MAP</a></span></dd>
              </dl>
              <dl>
                <dt>撮影者:</dt>
                <dd>みやちゃん</dd>
              </dl>
              <dl>
                <dt>投稿日:</dt>
                <dd>2013年01月04日 13時34分26秒</dd>
              </dl>
            </div>
            <div class="line-comment-box">亘理町吉田付近を地震後の津波襲来前の平成23年3月11日に撮影。</div>
          </div>
          <div class="btn-det-box"><router-link to="/uuid">詳しく見る <img src="../assets/arw_r.png" alt=""></router-link></div>
        </div>
      </div>

      <div class="line-sbox">
        <h4 class="line-title">宮城県 亘理郡亘理町 吉田</h4>
        <div class="line-thumb"><router-link to="/uuid"><img src="../assets/logo.png" alt="" /></router-link></div>
        <div class="line-info-rbox">
          <div class="line-info-box">
            <div class="line-info-sbox">
              <dl>
                <dt>作成日(撮影日)</dt>
                <dd>2012年02月17日 08時36分00秒</dd>
              </dl>
              <dl>
                <dt>撮影場所</dt>
                <dd>宮城県 亘理郡亘理町 吉田<span><a href="http://maps.google.co.jp/maps?q=%E5%AE%AE%E5%9F%8E%E7%9C%8C+%E4%BA%98%E7%90%86%E9%83%A1%E4%BA%98%E7%90%86%E7%94%BA+%E5%90%89%E7%94%B0&hl=ja&ie=UTF8&sll=38.005799,140.856633&sspn=0.176379,0.259552&brcurrent=3,0x5f8a13e473af7b3b:0xf22068a70b5e9ef2,0&hnear=%E5%AE%AE%E5%9F%8E%E7%9C%8C%E4%BA%98%E7%90%86%E9%83%A1%E4%BA%98%E7%90%86%E7%94%BA%E5%90%89%E7%94%B0&t=m&z=12" class="btn-map-s" target="_blank">MAP</a></span></dd>
              </dl>
              <dl>
                <dt>撮影者:</dt>
                <dd>みやちゃん</dd>
              </dl>
              <dl>
                <dt>投稿日:</dt>
                <dd>2013年01月04日 13時34分26秒</dd>
              </dl>
            </div>
            <div class="line-comment-box">亘理町吉田付近を地震後の津波襲来前の平成23年3月11日に撮影。</div>
          </div>
          <div class="btn-det-box"><router-link to="/uuid">詳しく見る <img src="../assets/arw_r.png" alt=""></router-link></div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
 export default {
     computed: {
         items: function(){
             return this.$store.getters.items;
         },

     },
     created(){
         this.$emit('itemmode','line');
         
     },

     methods:{

         maplink(item){
             if(item.lat && item.lon) return 'https://maps.gsi.go.jp/#16/' + item.lat + '/' + item.lon
             return null;
         }

     }
 }
</script>
<style>
 /*---------------------------------

    line

    ----------------------------------*/

 .line-box {
     clear: both;
     margin-top: 5px;;
 }

 .line-sbox {
     padding: 15px 0;
     border-bottom: 1px solid #332C59;
     position: relative;
     overflow: hidden;
     min-height: 210px;
 }

 .line-thumb {
     width: 180px;
     overflow: hidden;
     margin-right: 15px;
     float: left;
     position: absolute;
     left: ;
     top: 15px;
     /*border: 1px solid #fff;
        box-shadow: 0 1px 1px 2px rgba(0,0,0,0.05);*/
 }

 .line-thumb img{
     width: auto;
     height: 180px;
 }

 .line-title {
     /*width: 640px;*/
     font-size: 115%;
     /*border-bottom: 1px solid #332C59;*/
     padding-left: 1em;
     background: url(../assets/lh_c.png) no-repeat left 6px;
     line-height: 1.4;
     margin-bottom: 5px;
     margin-left: 200px;
 }


 .line-title span{
     margin-left:20px;
     display: block;
 }

 .line-info-rbox {
     margin-left: 200px;
 }

 .line-info-box {
     margin-left: 1.3em;
 }

 .line-comment-box {
     float: left;
     width: 48%;
     margin-left: 2%;
 }

 .line-info-sbox {
     float: left;
     width: 47%;
     padding-right: 2%;
     padding-left: 0;
     border-right: 1px dotted #332C59;
 }

 .line-info-sbox dl dt{
     float: left;
     width: 8em;
     font-weight: bold;
 }

 .line-info-sbox dl dd{
     margin-left: 8em;
 }
 .btn-det-box a{
     position: absolute;
     display: block;
     padding: 5px 15px 5px 20px;
     text-align: center;
     background-color: #332C59;
     color: #fff !important;
     box-sizing: border-box;
     right: 0;
     bottom: 15px;
     font-weight: bold;
 }
 span a.btn-map-s {
     margin-left: 10px;
     padding: 2px 10px;
     line-height: 1;
     text-align: center;
     border: 1px solid #332C59;
     color: #332C59;
     box-sizing: border-box;
     /*-moz-border-radius:5px;
        -khtml-border-radius:5px;
        -webkit-border-radius:5px;
        border-radius:3px;*/
     font-size: 80%;
     display: inline-block;
     background: url(../assets/map.png) no-repeat 38px center;
     padding-right: 20px;
 }

 span a.btn-map-s:hover {
     opacity: 0.7;
 }


 /*@media screen and (max-width:1610px) {

    .top-n-info {
    min-height: 150px;
    }

    }*/

 @media screen and (max-width:1460px) {

 }


 /* 1120px (Small Desktop, Netbook) */
 @media screen and (max-width:1350px) {
     .line-info-sbox dl dt {
         float: none;
         width: 8em;
     }

     .line-info-sbox dl dd {
         margin-left: 0;
         margin-bottom: 10px;
     }

 }


 @media screen and (max-width:1180px) {

     .line-info-box {
         padding-bottom: 50px;
     }

     .line-info-sbox {
         float: none;
         width: 100%;
         padding-right: 0;
         border-right: none;
     }

     .line-comment-box {
         float: none;
         width: 100%;
         margin-left: 0;
     }

 }


 @media screen and (max-width:991px) {

 }


 @media screen and (max-width:850px) {

 }


 @media screen and (max-width:770px) {

     /*list*/

     .select-box {
         padding-bottom: 12px;
     }

     .control-label {
         display: none;
     }

     .line-box {
         font-size: 95%;
         line-height: 1.5;
     }
     .line-sbox {
         border-bottom: 1px dotted #332C59;
     }
     .line-thumb {
         position: inherit;
         margin-top: -10px;
     }

     .line-title {
         padding-bottom: 3px;
         margin-bottom: 10px;
         margin-left: 0;
         border-bottom: 1px solid #332C59;
         background-position: left 5px;
     }

     .line-thumb {
         width: 105px;
     } 

     .line-thumb img {
         height: 105px;
     }

     .line-info-rbox {
         margin-left: 115px;
     }

     .line-info-box {
         padding-bottom: 40px;
         margin-left: 5px;
     }

    aside {
        position: absolute;
    }

 }


 /* 320px (iPhone) */
 @media screen and (max-width:480px) {
 }

</style>
